<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col cols="12" sm="9">
          <h2>{{ mission.questionName || '• • •' }}</h2>
        </v-col>
        <v-col cols="12" sm="3" class="d-flex justify-end">
          <v-btn rounded color="error" :to="{name:'PageFamilyUserMissionRemove',params:{id:$route.params.id,parentId:$route.params.parentId}}">Remove</v-btn>
        </v-col>
      </v-row>
      <ALoader :isLoading="api.isLoading" />
      <Read
        v-if="!api.isLoading"
        :headers="missionHeaders"
        :data="mission"
      />
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
import Read from "../../components/Bread/Mission/Read.vue";
export default {
  components: {
    Read,
    //
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  // computed: mapState({
  //     auth: (state) => state.auth.data,
  //   }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    mission: {},
    questionName: '',
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    questionApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      params: {},
    },
    //EOC
    missionHeaders: [
      { text: "Name", value: "questionName" },
      { text: "Status", value: "status" },
      { text: "Grade", value: "grade" },
      { text: "Stars", value: "stars" },
      { text: "Assigned At", value: "timestampCreated" },
      { text: "Last Played", value: "timestampUpdated" },
    ],
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageFamilyDashboard" },
        exact: true,
      },
      {
        text: "User Info",
        to: {
          name: "PageFamilyUserRead",
          params: { id: this.$route.params.parentId },
        },
        exact: true,
      },
      {
        text: "Mission Info",
        to: {
          name: "PageFamilyUserMissionRead",
          params: { id: this.$route.params.id },
        },
        exact: true,
      },
    ];
    //EOC

    this.api.method = "GET";
    this.api.url =
      this.$api.servers.game +
      "/api/v1/" +
      this.$_getLocale() +
      "/backend/player/" +
      this.$route.params.parentId +
      "/mission/" +
      this.$route.params.id;

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.mission = resp;
      // Fetch question name if questionKey exists
      if (resp && resp.questionKey) {
        this.fetchQuestionName(resp.questionKey);
      }
    };
  },
  mounted() {
    this.$api.fetch(this.api);
  },
  methods: {
    fetchQuestionName(questionKey) {
      if (!questionKey) return;
      this.questionApi.method = 'post';
      this.questionApi.url = `${process.env.VUE_APP_URL_API_QUESTION}/v2/questions`;
      this.questionApi.callbackReset = () => {
        this.questionApi.isLoading = true;
        this.questionApi.isError = false;
      };
      this.questionApi.callbackError = (e) => {
        this.questionApi.isLoading = false;
        this.questionApi.isError = true;
        this.questionApi.error = e;
      };
      this.questionApi.callbackSuccess = (resp) => {
        this.questionApi.isLoading = false;
        if (resp && resp.length) {
          const q = resp[0];
          this.questionName = q.name || q.questionName || questionKey;
          // Also update mission.questionName for table display
          this.$set(this.mission, 'questionName', this.questionName);
        }
      };
      this.questionApi.params = {
        key: questionKey,
        lang: this.$_getLocale(),
        count: 1,
        showOption: false,
      };
      this.$api.fetch(this.questionApi);
    },
    // ...existing code...
    // updateBreadcrumb(resp) {
    //   this.breadcrumbs.push({
    //     text: "Dashboard",
    //     to: { name: "PageEducatorDashboard" },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: resp.Institution.name,
    //     to: { name: "PageEducatorInstitutionDashboard",params:{id:this.$route.params.parentId} },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //   text: "Teachers",
    //   to: { name: "PageEducatorInstitutionTeacher" ,params:{id:this.$route.params.parentId} },
    //   exact: true,
    // });
    // this.breadcrumbs.push({
    //   text: resp.User.name,
    //   to: { name: "PageEducatorInstitutionTeacherRead" ,params:{id:this.$route.params.id,parentId:this.$route.params.parentId,grandparentId:this.$route.params.grandparentId} },
    //   exact: true,
    // });
    // },
  }
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>